module.exports = __webpack_public_path__ + "static/profile-3fde96097633fa21eae5ec56b033d359.gif";